import { useState } from 'react';

import PropTypes from 'prop-types';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import { infoIcon, openUrlInNewTab } from '../../utils';

import { getInfoTypes } from './constants';

import { ButtonLink } from '../Button';
import Tooltip from './index';

const InfoComponent = ({ type, height, isOnHover, isTooltip }) => {
  const { t } = useTransl();
  const [isHovered, setIsHovered] = useState(false);
  const data = getInfoTypes(t)[type];
  const { url, title } = data;
  if (isTooltip) {
    return (
      <Tooltip placement="top" trigger="hover" tooltip={title}>
        <Box display="flex" mx=".5rem">
          <InfoOutlinedIcon fontSize="small" />
        </Box>
      </Tooltip>
    );
  }
  if (isOnHover) {
    return (
      <>
        <ButtonLink
          type="button"
          onClick={() => url && openUrlInNewTab(url)}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ display: 'flex' }}
          aria-label={t('altLabel.infoIcon')}
        >
          <img
            style={{ height: `${height}rem` }}
            src={infoIcon}
            alt={t('altLabel.infoIcon')}
          />
        </ButtonLink>
        {isHovered ? <div>{title}</div> : null}
      </>
    );
  }
  return (
    <>
      <img
        style={{ height: `${height}rem` }}
        src={infoIcon}
        alt={t('altLabel.infoIcon')}
      />
      <div>{title}</div>
    </>
  );
};

InfoComponent.defaultProps = {
  height: 1.6,
  isOnHover: true,
  isTooltip: false,
};

InfoComponent.propTypes = {
  type: PropTypes.string.isRequired,
  isTooltip: PropTypes.bool,
  height: PropTypes.number,
  isOnHover: PropTypes.bool,
};

export default InfoComponent;
